
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"currentColor","cx":"12","cy":"12","r":"11"}}),_c('path',{attrs:{"d":"M9.44 11.719a.99.99 0 00-1.596 1.172l2.384 3.247a.99.99 0 001.577.026l5.546-7.056a.99.99 0 10-1.557-1.223l-4.74 6.03L9.44 11.72z","fill":"#FFF"}})])])
          )
        }
      }
    